import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Filters } from '../filters/filter.interface';
import { CallList, CallListImport, CallListSearchResult } from './call-list.interface';
import { CallListService } from './call-list.service';
import candidate, { CandidateState } from './candidates/candidate.store';

const service = new CallListService();

export interface CallListState {
   callLists: Array<CallList>;
   selectedCallListId?: number;
   candidate?: CandidateState;
   filters?: Filters;
   activeIndex: number;
}

const CallListStore: Module<CallListState, StoreState> = {
   namespaced: true,
   state: {
      callLists: [],
      activeIndex: 0,
   },
   getters: {
      callLists: (state) => state.callLists,
      activeIndex: (state) => state.activeIndex,
   },
   mutations: {
      SET_CALL_LISTS(state, callLists: Array<CallList>) {
         state.callLists = callLists;
      },
      ADD_CALL_LIST(state, callList: CallList) {
         state.callLists.push(callList);
      },
      UPDATE_CALL_LIST(state, callList: CallList) {
         const newCallList = state.callLists?.filter((call) => call.id !== callList.id);
         newCallList.push(callList);
         state.callLists = newCallList;
      },
      SET_SELECTED_CALL_LIST_ID(state, callListId: number) {
         state.selectedCallListId = callListId;
      },
      DELETE_CALL_LIST(state, callListId: number) {
         const newCallList = state.callLists?.filter((callList) => callList.id !== callListId);
         state.callLists = newCallList;
         delete state.selectedCallListId;
      },
   },
   actions: {
      async getCallLists(context) {
         const response = await service.getCallLists();
         context.commit('SET_CALL_LISTS', response.data);
         return response.data;
      },
      async searchCallList(context, body: CallListImport): Promise<CallListSearchResult> {
         const response = await service.searchCallList(body);
         const { failedLookups: responseFailedLookups, ...candidatePage } = response;
         const failedLookups = responseFailedLookups ?? { count: 0, file: null };
         context.commit('candidate/ADD_CANDIDATES', candidatePage);
         return {
            candidates: response.data,
            failedLookups,
         };
      },
      async createCallList(context, callList: CallList) {
         const response = await service.postCallList(callList);
         context.commit('ADD_CALL_LIST', response.data);
         context.commit('SET_SELECTED_CALL_LIST_ID', response.data.id);
         return response.data;
      },

      async updateCallList(context, callList: CallList) {
         const response = await service.putCallList(callList);
         context.commit('UPDATE_CALL_LIST', response.data);
         return response.data;
      },

      async deleteCallList(context, callListId: number) {
         const response = await service.deleteCallList(callListId);
         context.commit('DELETE_CALL_LIST', callListId);
         return response;
      },
   },
   modules: {
      candidate,
   },
};

export default CallListStore;
